export const ApiFilesUrls = {
  choices: '/files/api-schema',
};
